import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import TableActions from "@components/TableActions";
import { TicketType } from "@type/tickets/ticket-types";
import { TicketTypeSettingsType } from "@type/tickets/ticket-settings";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  setSelectedId: any,
  setIsUpdateModalOpen: any,
  openConfirmationModel: (itemName: string, id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("TICKETS.SETTINGS.TAB.TYPE.TABLE.COLUMN.TYPE"),
      render: (name: string) => (
        <Text weight="semibold" color="info">
          {name}
        </Text>
      ),
    },
    {
      id: 2,
      key: "createdAt",
      name: t("TICKETS.SETTINGS.TAB.TYPE.TABLE.COLUMN.DATE_CREATED"),
      render: (createdAt: string) => <Text color="subtitle2">{createdAt}</Text>,
    },
    {
      id: 3,
      key: "updatedAt",
      name: t("TICKETS.SETTINGS.TAB.TYPE.TABLE.COLUMN.DATE_UPDATED"),
      render: (updatedAt: string) => <Text color="subtitle2">{updatedAt}</Text>,
    },
    {
      id: 3,
      key: "id",
      name: "",
      render: (id: string | number, row: TicketTypeSettingsType) => {
        return (
          <TableActions
            onClickEdit={() => {
              setIsUpdateModalOpen(true);
              setSelectedId(id);
            }}
            onClickDelete={() => openConfirmationModel(row?.name, id)}
          />
        );
      },
    },
  ];
};
